export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/accident-insurance.f8fc1100.svg","height":360,"width":462};